import { createContext } from "react";

const Context = createContext({
    test: null
});

export default Context;
